import { cx } from "@emotion/css";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { useTranslation } from "react-i18next";
import type { DeckCategoryOption } from "src/api/flashcardDecks";

type DecksFiltersProps = {
	details: Record<string, unknown>;
	setDetails: (details: Record<string, unknown>) => void;
	categories?: DeckCategoryOption[];
};

export function DecksFilters({
	details,
	setDetails,
	categories = [],
}: DecksFiltersProps) {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-12">
			<span className="size-18">
				{t("search.filters.chips.author", "Autor")}
			</span>
			<RadioGroup
				className="gap-8"
				value={String(details.author)}
				onChange={(_event, author) => setDetails({ ...details, author })}
			>
				{categories.map(({ value: author, label }) => (
					<FormControlLabel
						key={author}
						value={author}
						control={<Radio />}
						label={label}
						className={cx("radio-tile border-medium-grey border-radius-12", {
							"border-color-primary": details.author === author,
						})}
						data-test-id={`decks-filter-author-${author}`}
					/>
				))}
			</RadioGroup>
		</div>
	);
}
